// EXCLUDED FROM PERSIST-GATE

export const SET_PAGE_LOADING = "PAGE_OPTIONS/SET_PAGE_LOADING";
export const SET_PERSIST_DATES = "PAGE_OPTIONS/SET_PERSIST_DATES";


export const setPageLoading = loadingState => ({
    type: SET_PAGE_LOADING,
    loadingState
})

export const setPersistDates = persistDates => ({
    type: SET_PERSIST_DATES,
    persistDates
})

export default function reducer(state = {
    blocking: true,
    persistDates: false
}, action) {
    switch (action.type) {
        case SET_PAGE_LOADING: {
            return {
                ...state,
                blocking: action.loadingState
            }
        }
        case SET_PERSIST_DATES: {
            return {
                ...state,
                persistDates: action.persistDates
            }
        }
        default:
            return state;
    }
}